import React, { FunctionComponent } from 'react'
import Badge from '../../../etc/Badge/Badge'
import Button from '../../../controls/Button/Button'
import TaskIcon from 'files/task-open.svg'
import SidePanel from '../../../etc/SidePanel/SidePanel'
import { AnimatePresence } from 'framer-motion'
import { useBoolean, useRootDispatch, useRootSelector } from '../../../../utils/hooks'
import { useUpdateEffect } from 'react-use'
import { taskActions } from '../../../../redux/data/task/task-actions'
import UserTasks from '../../../data-components/UserTasks/UserTasks'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../../http/routes'
import ChevronRightIcon from 'files/chevron/right.svg'
import { useQueries } from '../../../../utils/hooks/useQueries'
import { Colors } from '../../../../styles'

const TasksPanel: FunctionComponent<{className?: string}> = props => {
    const dispatch = useRootDispatch()
    const user = useRootSelector(state => state.global.user.data)
    const { state: open, setTrue, setFalse } = useBoolean(false)

    const {isMobile} = useQueries()

    useUpdateEffect(() => {
        (user?.id && open) && dispatch(taskActions.user.request(user.id))
    }, [open, user?.id])

    return <Badge className={props.className} color={Colors.blue} badge={user?.targeted_tasks}>
        <Button
            // todo решить с исключением
            // intent={Intent.DARK}
            title={'Текущие задачи'}
            onClick={setTrue}
        >
            <TaskIcon/>
        </Button>
        <AnimatePresence>
            {
                open && <SidePanel
                    onClose={setFalse}
                    header={'Текущие задачи'}
                >
                    <UserTasks user={user} onClick={setFalse}/>
                    {
                        isMobile && <Link to={ROUTES.TASKS}>
                            <Button>
                                <ChevronRightIcon/>
                                Все задачи
                            </Button>
                        </Link>
                    }
                </SidePanel>
            }
        </AnimatePresence>
    </Badge>
}

export default TasksPanel